import React from "react";
import { Box } from "@mui/material";
import { useAgency } from "../../hooks/useAgency";
import ViewModeToggle from "../ViewModeToggle";

const Header = ({ children }) => {
  const { agency } = useAgency();

  return (
    <Box sx={{ position: "relative", padding: 3, textAlign: "center" }}>
      {/* #50 — principal agent/agency view toggle (renders only for principals
          linked to an agent record). */}
      <Box sx={{ position: "absolute", top: 12, right: 12 }}>
        <ViewModeToggle />
      </Box>
      {agency && <img alt={agency.name} width="190" src={agency.logo.src} />}
    </Box>
  );
};

export default Header;
